package one.healthium.tasks.domain

import one.healthium.domain.user.UserEvents
import one.healthium.insights.ui.content.ContentEvents

class TasksCompletionEventsHandler(
    private val tasksRepository: DailyTasksRepository
) : UserEvents, ContentEvents {
    override suspend fun onWaterIntakeAdded(taskId: String?) {
        if (taskId != null) {
            tasksRepository.completeTaskById(taskId)
        } else {
            tasksRepository.completeTodayTaskByType(DailyTaskType.LogWater)
        }
    }

    override suspend fun onWeightUpdated(taskId: String?) {
        if (taskId != null) {
            tasksRepository.completeTaskById(taskId)
        } else {
            tasksRepository.completeTodayTaskByType(DailyTaskType.LogWeight)
        }
    }

    override suspend fun onFoodAdded(taskId: String?) {
        if (taskId != null) {
            tasksRepository.completeTaskById(taskId)
        } else {
            tasksRepository.completeTodayTaskByType(DailyTaskType.LogFood)
        }
    }

    override suspend fun onSymptomsAdded(taskId: String?) {
        if (taskId != null) {
            tasksRepository.completeTaskById(taskId)
        } else {
            tasksRepository.completeTodayTaskByType(DailyTaskType.LogSymptoms)
        }
    }

    override suspend fun onInsightOpened(id: String) {
        tasksRepository.completeTodayTaskByType(DailyTaskType.ReadInsight(id))
    }

    override suspend fun onWorkoutOpened(id: String) {
        tasksRepository.completeTodayTaskByType(DailyTaskType.DoWorkout(id))
    }

    override suspend fun onHealthLogAdded(taskId: String?) {
        onSymptomsAdded(taskId)
    }
}